<picture [class]="classNamePicture">
  <source [srcset]="imageSmall" media="(max-width: 480px)" />
  <source [srcset]="imageMedium" media="(max-width: 1024px)" />
  <source [srcset]="imageDefault" media="(max-width: 1921px)" />
  <img
    [src]="imageDefault"
    [alt]="alternativeText"
    [class]="classNameImage"
    loading="lazy"
  />
</picture>
